<!-- *************************************************************************
    TEMPLATE
    ************************************************************************* -->
<template>
  <div>
    <PageTitle
      title="Supplier View"
      :backBtn="true"
      :editRoute="'/supplier/edit/' + this.$route.params.id"
      :permission="'Supplier Edit'"
    />

    <v-container fluid class="lighten-12 container">
      <v-row>
        <v-col cols="12" sm="12" md="12" lg="4">
          <v-row>
            <v-col cols="12" sm="12" md="12" lg="12">
              <v-card class="lighten-12">
                <v-card-title class="v-card__title saletiltle"
                  ><v-icon color="blue" small>mdi-account-convert</v-icon>
                  <span class="pl-3">Supplier Details</span></v-card-title
                >
                <v-container fluid class="container saledetailscard">
                  <v-row>
                    <v-col cols="12" sm="12" md="12" lg="12" class="pt-0">
                      <v-row class="pt-0">
                        <v-col
                          cols="12"
                          sm="12"
                          md="9"
                          lg="9"
                          class="pr-5pt-1.5 pb-1 reference_number"
                        >
                          <span>{{ this.name }}</span>
                        </v-col>
                        <v-col cols="12" sm="12" md="3" lg="3" class="shoptext">
                          <v-row>
                            <v-chip
                              style="
                                color: white;
                                font-variant-caps: all-small-caps;
                                font-weight: bold;
                              "
                              text-color="white"
                              :color="getStatusColor(this.status)"
                              dark
                              label
                              >{{ this.status ? 'Active' : 'Archived' }}</v-chip
                            >
                          </v-row>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col
                          cols="12"
                          sm="12"
                          md="6"
                          lg="6"
                          class="shoptext pr-5 pt-0"
                        >
                          <v-row class="subtextlable"> Code </v-row>
                          <v-row>
                            {{ this.code }}
                          </v-row>
                        </v-col>
                        <v-col
                          cols="12"
                          sm="12"
                          md="6"
                          lg="6"
                          class="shoptext pr-5 pt-0"
                        >
                          <v-row class="subtextlable"> Ref Number </v-row>
                          <v-row>
                            {{ this.reference_number }}
                          </v-row>
                        </v-col>
                      </v-row>

                      <v-row>
                        <v-col
                          cols="12"
                          sm="12"
                          md="12"
                          lg="12"
                          class="shoptext"
                        >
                          <v-row>
                            Available Balance :
                            <v-chip
                              v-if="this.AccountDetails.available_balance < 0"
                              label
                              text-color="white"
                              style="font-weight: bold"
                              color="red"
                              class="ma-0 mt-0 ml-2"
                              dark
                              >{{
                                -this.AccountDetails.available_balance
                                  | formatCurrency
                              }}</v-chip
                            >
                            <v-chip
                              v-else
                              :x-small="true"
                              style="font-weight: bold; font-size: revert"
                              class="ma-0 ml-2"
                              label
                              text-color="white"
                              color="green"
                              dark
                              >{{
                                this.AccountDetails.available_balance
                                  | formatCurrency
                              }}</v-chip
                            >
                          </v-row>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12" sm="12" md="12" lg="4">
          <v-row>
            <v-col cols="12" sm="12" md="12" lg="12">
              <v-card class="lighten-12">
                <v-card-title class="v-card__title saletiltle"
                  ><v-icon color="blue" small>mdi-city</v-icon
                  ><span class="pl-3"> Address</span>
                </v-card-title>
                <v-container fluid class="container saledetailscard">
                  <v-row>
                    <v-col
                      cols="12"
                      sm="12"
                      md="12"
                      lg="12"
                      class="pt-0"
                      v-for="item in addresses"
                      :key="item.message"
                    >
                      <v-row>
                        <v-col
                          cols="12"
                          sm="12"
                          md="6"
                          lg="6"
                          class="shoptext pr-5 pt-0"
                        >
                          <v-row class="subtextlable"> Address Line 1 </v-row>
                          <v-row style="text-align: left">
                            {{
                              item.address_line1 ? item.address_line1 : '---'
                            }}
                          </v-row>
                        </v-col>
                        <v-col
                          cols="12"
                          sm="12"
                          md="6"
                          lg="6"
                          class="shoptext pr-5 pt-0"
                        >
                          <v-row class="subtextlable"> Address Line 2 </v-row>
                          <v-row style="text-align: left">
                            {{
                              item.address_line2 ? item.address_line2 : '---'
                            }}
                          </v-row>
                        </v-col>
                      </v-row>

                      <v-row>
                        <v-col
                          cols="12"
                          sm="12"
                          md="6"
                          lg="6"
                          class="shoptext pr-5 pt-0"
                        >
                          <v-row class="subtextlable"> City </v-row>
                          <v-row style="text-align: left">
                            {{ item.city ? item.city : '---' }}
                          </v-row>
                        </v-col>
                        <v-col
                          cols="12"
                          sm="12"
                          md="6"
                          lg="6"
                          class="shoptext pr-5 pt-0"
                        >
                          <v-row class="subtextlable"> Postal Code </v-row>
                          <v-row style="text-align: left">
                            {{ item.postal_code ? item.postal_code : '---' }}
                          </v-row>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col
                          cols="12"
                          sm="12"
                          md="6"
                          lg="6"
                          class="shoptext pr-5 pt-0"
                        >
                          <v-row class="subtextlable"> Country </v-row>
                          <v-row style="text-align: left">
                            {{ item.country ? item.country.name : '---' }}
                          </v-row>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                  <v-row v-if="addresses.length == 0">
                    <v-col cols="12" sm="12" md="12" lg="12" class="pt-0">
                      <div class="mt-16 container justify-center item-center">
                        <img
                          style="height: 50px"
                          src="../../../assets/img/01.gif"
                        />
                      </div>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12" sm="12" md="12" lg="4">
          <v-row>
            <v-col cols="12" sm="12" md="12" lg="12">
              <v-card class="lighten-12">
                <v-card-title class="v-card__title saletiltle"
                  ><v-icon color="blue" small>mdi-phone</v-icon
                  ><span class="pl-3"> Contact</span>
                </v-card-title>
                <v-container fluid class="container saledetailscard">
                  <v-row>
                    <v-col
                      cols="12"
                      sm="12"
                      md="12"
                      lg="12"
                      class="pt-0"
                      v-for="item in contacts"
                      :key="item.message"
                    >
                      <v-row>
                        <v-col
                          cols="12"
                          sm="12"
                          md="6"
                          lg="6"
                          class="shoptext pr-5 pt-0"
                        >
                          <v-row class="subtextlable"> Full Name </v-row>
                          <v-row style="text-align: left">
                            {{ item.full_name ? item.full_name : '---' }}
                          </v-row>
                        </v-col>
                        <v-col
                          cols="12"
                          sm="12"
                          md="6"
                          lg="6"
                          class="shoptext pr-5 pt-0"
                        >
                          <v-row class="subtextlable"> Telephone </v-row>
                          <v-row style="text-align: left">
                            <a
                              href=""
                              :style="
                                item.telephone && item.telephone
                                  ? { color: 'light-blue' }
                                  : { 'text-decoration': 'none' }
                              "
                            >
                              {{ item.telephone ? item.telephone : '---' }}</a
                            >
                          </v-row>
                        </v-col>
                      </v-row>

                      <v-row>
                        <v-col
                          cols="12"
                          sm="12"
                          md="6"
                          lg="6"
                          class="shoptext pr-5 pt-0"
                        >
                          <v-row class="subtextlable"> Phone </v-row>
                          <v-row style="text-align: left">
                            <a
                              href=""
                              :style="
                                item.phone && item.phone
                                  ? { color: 'light-blue' }
                                  : { 'text-decoration': 'none' }
                              "
                            >
                              {{ item.phone ? item.phone : '---' }}</a
                            >
                          </v-row>
                        </v-col>
                        <v-col
                          cols="12"
                          sm="12"
                          md="6"
                          lg="6"
                          class="shoptext pr-5 pt-0"
                        >
                          <v-row class="subtextlable"> Email </v-row>
                          <v-row style="text-align: left">
                            {{ item.email ? item.email : '---' }}
                          </v-row>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col
                          cols="12"
                          sm="12"
                          md="6"
                          lg="6"
                          class="shoptext pr-5 pt-0"
                        >
                          <v-row class="subtextlable"> Contactable Type </v-row>
                          <v-row style="text-align: left">
                            {{
                              item.contactable_type
                                ? item.contactable_type
                                : '---'
                            }}
                          </v-row>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                  <v-row v-if="contacts.length == 0">
                    <v-col cols="12" sm="12" md="12" lg="12" class="pt-0">
                      <div class="mt-16 container justify-center item-center">
                        <img
                          style="height: 50px"
                          src="../../../assets/img/01.gif"
                        />
                      </div>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card>
            </v-col>
          </v-row>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12" md="12" sm="12" lg="12">
          <v-card class="lighten-12">
            <v-card-title class="v-card__title producttiltle"
              ><v-icon color="blue" small>mdi-chart-pie</v-icon
              ><span class="ml-3"> Supplier Related Factors</span>
            </v-card-title>

            <v-container fluid class="container saledetailscard">
              <v-row>
                <v-col cols="12" sm="12" md="12" lg="12" class="pt-0">
                  <v-tabs horizontal background-color="primary" dark>
                    <v-tab> Products </v-tab>
                    <v-tab> Bank Details </v-tab>
                    <v-tab> Purchases </v-tab>
                    <v-tab> Purchase Order </v-tab>
                    <v-tab> Purchase Return </v-tab>
                    <v-tab> Payments </v-tab>

                    <v-tab-item>
                      <SupplierProductList />
                    </v-tab-item>
                    <v-tab-item>
                      <SupplierBankList />
                    </v-tab-item>
                    <v-tab-item>
                      <SupplierPurchaseList />
                    </v-tab-item>
                    <v-tab-item>
                      <SupplierPurchaseOrderList />
                    </v-tab-item>
                    <v-tab-item>
                      <SupplierPurchaseReturnList />
                    </v-tab-item>
                    <v-tab-item>
                      <SupplierPaymentsList />
                    </v-tab-item>
                  </v-tabs>
                </v-col>
              </v-row>
            </v-container>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>
<!-- *************************************************************************
    SCRIPT
    ************************************************************************* -->
<script>
//COMPONENTS
import SupplierPurchaseOrderList from './SupplierPurchaseOrderList';
import SupplierProductList from './SupplierProductList';
import SupplierPurchaseList from './SupplierPurchaseList';
import SupplierPurchaseReturnList from './SupplierPurchaseReturnList';
import SupplierBankList from './SupplierBankList';
import SupplierPaymentsList from './SupplierPaymentsList';

export default {
  data() {
    return {
      status: '',
      name: '',
      code: '',
      reference_number: '',
      addresses: '',
      contacts: '',
      maximum_credit_amount: '',
      payment_team: '',
      AccountDetails: '',
    };
  },
  components: {
    SupplierPurchaseOrderList,
    SupplierProductList,
    SupplierPurchaseList,
    SupplierPurchaseReturnList,
    SupplierBankList,
    SupplierPaymentsList,
  },
  methods: {
    getStatusColor(status) {
      return status ? 'green' : 'gray';
    },
    GetSupplier() {
      let supplierId = this.$route.params.id;
      this.$store
        .dispatch('supplier/GetSupplier', supplierId)
        .then((item) => {
          this.name = item.data.name ? item.data.name : '----';
          this.status = item?.data?.is_active;
          this.code = item.data.code ? item.data.code : '----';
          this.AccountDetails = item.data.account;
          this.reference_number = item.data.reference_number
            ? item.data.reference_number
            : '----';
          this.addresses = item.data.addresses ? item.data.addresses : '----';
          this.contacts = item.data.contact;
          this.maximum_credit_amount = item.data.maximum_credit_amount
            ? item.data.maximum_credit_amount
            : '------';
          this.payment_team = item.data.payment_team
            ? item.data.payment_team
            : '------';
        })
        .catch((err) => {
          this.messages = err.data.title;
        });
    },
  },
  created() {
    this.GetSupplier();
  },
};
</script>

<style>
.rowspace {
  margin-bottom: -38px;
  background-color: white;
}

.p-100 {
  padding-top: 0px;
}
/* .w-100 {
 
} */
.container {
  width: 100%;
  margin-right: auto;
  margin-left: auto;
  background-color: white;
  margin-bottom: -16px;
}
.reference_number {
  font-family: Roboto;
  font-style: normal;
  font-weight: bold;
  font-size: 18px;
  line-height: 21px;
  /* identical to box height */

  text-align: center;

  color: #000000;
}
.saletiltle {
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 16px;
}
.saledetailscard {
  background: #fffefe;
  box-sizing: border-box;
  border: 1px solid #afa9a9;
  box-shadow: inset 0px 4px 4px rgba(0, 0, 0, 0.25);
}
.subtextlable {
  font-family: Roboto;
  font-style: normal;
  font-weight: bold;
  font-size: 10px;
  line-height: 11px;
  /* identical to box height */

  text-align: left;

  color: #928686;
}
.shoptext {
  font-family: Roboto;
  font-style: normal;
  font-weight: bold;
  font-size: 12px;
  line-height: 14px;
  /* identical to box height */

  text-align: center;

  color: #000000;
}
</style>
